import util from '../libs/util'

/**
 * 配置静态路由
 * 分为两种路由：
 * 1.路由出口在App.vue
 * 2.路由出口在main.vue
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 */

// 1.路由出口在App.vue
const singleRoutes = [
  {
    // 设置初始页面
    path: '',
    redirect: '/guidepage'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/system-page/login/login.vue'),
    meta: {
      // 密码规则校验开关
      validatePaswd: true
    }
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: () => import('../views/component/update-pswd.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error-pages/404.vue')
  }
  // {
  //   path: '/event-add',
  //   name: 'eventAdd',
  //   component: () => import('../views/work-manage/event-manage/event-add.vue')
  // },
  // {
  //   path: '/dispute-add',
  //   name: 'disputeAdd',
  //   component: () => import('../views/work-manage/dispute-manage/dispute-add.vue')
  // }
]

/**
 * 路由出口在main.vue，包括了菜单项和非菜单页面
 * 若该页面属于菜单页面，需要添加type: 'menu'属性
 */
const staticTree = [
  {
    path: '/main',
    name: 'main-home',
    title: '首页',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/main/main.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        title: '首页',
        icon: 'ios-paper',
        type: 'menu',
        component: () => import('../views/home/home.vue')
      }
    ]
  }, {
    path: '/satistics',
    name: 'statistics',
    title: '统计大屏',
    icon: 'md-pie',
    type: 'menu',
    component: () => import('../views/statistics/statistics.vue'),
  },
  {
    path: '/satisticsSec',
    name: 'statisticsSec',
    title: '区级统计大屏',
    icon: 'md-pie',
    type: 'menu',
    component: () => import('../views/statistics/statisticsSec.vue'),
  }, {
    path: '/guidepage',
    name: 'guidepage',
    title: '导航页',
    icon: 'md-pie',
    type: 'menu',
    component: () => import('../views/statistics/guidepage.vue'),
  }, {
    path: '/map',
    name: 'map',
    title: '统计大屏地图',
    icon: 'md-pie',
    type: 'menu',
    component: () => import('../views/statistics/map.vue'),
  }, {
    path: '/mapSec',
    name: 'mapSec',
    title: '区级统计大屏地图',
    icon: 'md-pie',
    // type: 'menu',
    component: () => import('../views/statistics/mapSec.vue'),
  }, {
    path: '/zhny',
    name: 'zhny',
    title: '智慧农业',
    icon: 'md-pie',
    // type: 'menu',
    component: () => import('../views/zhny/zhny.vue'),
  }
]
const staticMenuList = util.getMenuList(staticTree)
const staticMainRoutes = util.getMenuRoutes(staticTree)

// 汇总所有的路由
const staticRoutes = [...staticMainRoutes, ...singleRoutes]

export {staticRoutes, staticMenuList, staticTree}
